module.exports = __webpack_public_path__ + "assets/images/sample-big1.4ffe2d97.png";